import dom from "../../../dist/jsx-render/dom"
import { ColumnBase } from "./ColumnBase";
import { app } from "../../Frame/App";
import { MsoTable } from "./MsoTable";
import { ITableColumn } from "./ITableColumn";

declare var getCustomProgressBarColors;

export class ColumnProgress extends ColumnBase {
    protected cssColor: string;
    private useCustomColor: boolean;

    public constructor(table: MsoTable, def: ITableColumn, protected rootId: string) {
        super(table, def, rootId);
        this.cssColor = def.cssClass;

        if (app.getAppInitialDataSetting("useCustomProgressbarColors") === true) {
            this.useCustomColor = true;
        }
    }

    public getContent(row: any): HTMLElement {
        let progress = row[this.field] ? row[this.field].toFixed(0) : 0;
        let divOuter = <div className="progress-outer"></div>;
        let divInnerLeft = <div className="progress-left cf-color"></div>;
        divInnerLeft.style.width = progress.toString() + "%";

        let color: string;
        if (this.useCustomColor && window.hasOwnProperty('getCustomProgressBarColors')) {
            let colorField = getCustomProgressBarColors(this.def.dataField);
            if (colorField) color = row[colorField];
        }

        if (!color && (this.cssColor != null || this.cssColor != "")) {
            color = this.cssColor.replace("mt-progressbar-", "");
        }

        if (color) (divInnerLeft as HTMLElement).style.setProperty("background-color", color);

        if (progress >= 10)
            divInnerLeft.appendChild(<span>{progress.toString() + "%"}</span>);
        divOuter.appendChild(divInnerLeft);

        var divInnerRight = <div className="progress-right"></div>;
        divInnerRight.style.width = (100 - progress).toString() + "%";
        divOuter.appendChild(divInnerRight);

        return divOuter;
    }

    public getCellClass(): string {
        let className = super.getCellClass() + " mt-progress";
        return className;
    }

    public compare(modelA: any, modelB: any, asc: boolean): number {
        let aValue = app.anyToInt(modelA[this.field], 0);
        let bValue = app.anyToInt(modelB[this.field], 0);

        if (asc) {
            return aValue - bValue;
        }
        else {
            return bValue - aValue;
        }
    }

    // TODO
    /*public getUniqueVisibleItems(table: MsoTable): Array<ListItem> {
        let result = new Array<ListItem>();
        let dict: { [id: number]: number } = {};
        for (let model of this.getRowModelsForFilter(table)) {
            const ampel = app.anyToInt(model[this.field]);
            if (!(ampel in dict)) {
                dict[ampel] = 1;
            }
        }

        for (let ampel in dict) {
            switch (ampel) {
                case "0":
                    result.push({ id: ampel, name: "in Verzug" });
                    break;
                case "1":
                    result.push({ id: ampel, name: "fällig" });
                    break;
                case "2":
                    result.push({ id: ampel, name: "offen" });
                    break;
                case "3":
                    result.push({ id: ampel, name: "abgeschlossen" });
                    break;
            }
        }

        result.sort((a: ListItem, b: ListItem): number => {
            return a.name.localeCompare(b.name);
        });

        return result;
    }*/
}